
import { locale } from './globals.js';
import { initValidation, validate } from './form-validator';

const forms = [];

function SmartForm(el) {
	this.el = el;
	this.init();
};
SmartForm.prototype.init = function() {
  this.id = `f${forms.length-1}`
	this.el.setAttribute('novalidate', '');
	this.el.setAttribute('data-state', 'ready');
  this.requireds = this.el.querySelectorAll('[required]');

	if (this.el.hasAttribute('data-api')) {
		this.el.addEventListener('submit', this.submitHandler.bind(this));
	}
	this.requireds.forEach((elem, index) => {
		initValidation(elem);
	});

	this.submitBtn = this.el.querySelector('[type="submit"]');
	if(this.submitBtn.hasAttribute('data-require')) {
		this.initSubmitDisable();
	}
}
SmartForm.prototype.initSubmitDisable = function () {
	var requirement = this.el.querySelector(this.submitBtn.getAttribute('data-require'));
	this.submitBtn.disabled = !validate(requirement);
	requirement.addEventListener('input', (event) => {
		this.submitBtn.disabled = !validate(requirement);
	})
}
SmartForm.prototype.validateForm = function() {
	var valid = true;
	this.requireds.forEach((elem) => {
		validate(elem);
		if(elem.getAttribute('data-state') === 'error') valid = false;
	})
	return valid;
}
SmartForm.prototype.submitHandler = function (event) {
	event.preventDefault();
  event.stopPropagation();

	if(!this.validateForm()) return;

	// get api url
	this.api = this.el.getAttribute('data-api');

	this.setState('working');
	if (this.responseBox) this.responseBox.remove();

	if (this.api.length == 0 || this.api == 'test') {
		var testState = (this.el.hasAttribute('data-test-state')) ? this.el.getAttribute('data-test-state') : 'error';
		setTimeout(function(){
	    this.setState(testState);
	  }.bind(this), 1000);
	  return;
	}
	this.submitData();
}
SmartForm.prototype.submitData = function() {
	var XHR = new XMLHttpRequest();
  var FD = new FormData(this.el);
  // Success
  XHR.addEventListener('load', (event) => {
		this.response = JSON.parse(event.target.responseText);
		if(event.target.status == 200) {
			this.setState('success');
		} else {
			this.setState('error');
		}
	});
	XHR.open("POST", this.api);
  XHR.send(FD);
}
SmartForm.prototype.setState = function(state) {
	this.el.setAttribute('data-state', state);
	this.state = state;
	if (state == 'error') {
		// if(this.el.hasAttribute('data-response')) {
			this.displayResponse();
			requestAnimationFrame(() => {
				this.setState('error-response');
			})
		// }
		setTimeout(function(){
			this.el.setAttribute('data-state', 'ready');
			if (this.responseBox) this.responseBox.remove();
		}.bind(this), 4000);
	}
	if (state == 'success') {
		setTimeout(function(){
			if(this.el.hasAttribute('data-redirect')) {
				window.location.pathname = this.el.getAttribute('data-redirect');
			}
			if(this.el.hasAttribute('data-collapse')) {
				this.el.classList.add('collapse');
			}
			// if(this.el.hasAttribute('data-success-response')) {
				this.displayResponse();
			// }
			requestAnimationFrame(() => {
				this.setState('success-response');
			})
		}.bind(this), 1000);
	}
}
SmartForm.prototype.displayResponse = function() {
	if(this.response == undefined) {
		if (this.state == 'success') {
			this.response = {
				message: (this.el.getAttribute('data-success-response').length > 0) ? this.el.getAttribute('data-success-response') : 'Thank you!'
			}
		}
		if (this.state == 'error') {
			this.response = {
				message: (this.el.getAttribute('data-error-response').length > 0) ? this.el.getAttribute('data-error-response') : 'Error!'
			}
		}
		
	}
	this.responseBox = document.createElement('div');
	this.responseBox.classList.add('response-box');
	this.responseBox.innerHTML = this.response.message;
	this.el.parentNode.insertBefore(this.responseBox, this.el.nextSibling);
}

export function initAll () {
	Array.from(document.querySelectorAll('[data-smart-form]')).forEach(function(elem, index) {
		init(elem);
	});
};
export function init(elem) {
	if(elem.hasAttribute('data-state')) return;
  forms.push(elem)
  var form = new SmartForm(elem);
}

export default function (elem) {
	if (!elem || elem.length < 1) {
		initAll();
	} else {
	  init(elem);
	}
}
